import { generatePath } from "react-router-dom";
import { ROUTES } from "@/routes_new";
import { SearchLight } from "@/types/Search";
import { SearchItem } from "./SearchItem";

export function ActiveSearches({
  activeSearches,
  orgUuid,
  pathname,
  onDelete,
}: {
  activeSearches: SearchLight[];
  orgUuid: string;
  pathname: string;
  onDelete: (searchUuid: string) => void;
}) {
  return activeSearches.map((search) => {
    const to = generatePath(ROUTES.MENTION_DETAIL_ORGID, {
      orgUuid,
      uuid: search.uuid,
    });

    return (
      <SearchItem
        key={search.uuid}
        to={to}
        search={search}
        orgUuid={orgUuid}
        pathname={pathname}
        onDelete={() => onDelete(search.uuid)}
      />
    );
  });
}
